import { useEffect } from 'react';
import type { TConfirmEntityPlanState } from '../confirmEntityPlanState';

/**
 * Logs why the plan could not be shown (the reason only), and when a failed refresh left an
 * earlier plan on screen. Each is logged once per change.
 */
export function useLogPlanProblems(state: TConfirmEntityPlanState, hasFailedRead: boolean) {
  const errorReason = state.status === 'error' ? state.reason : undefined;
  useEffect(() => {
    if (errorReason) {
      console.error('Confirm entity plan could not be shown', { reason: errorReason });
    }
  }, [errorReason]);

  const isKeepingPlanAfterFailedRefresh = state.status === 'loaded' && hasFailedRead;
  useEffect(() => {
    if (isKeepingPlanAfterFailedRefresh) {
      console.error('Confirm entity plan refresh failed; keeping the loaded plan');
    }
  }, [isKeepingPlanAfterFailedRefresh]);
}
